//Formik
import FormikNumberInput from "../../../../../helpers/formikInputs/FormikNumberInput"
import { useField } from "formik"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"
import elementTypes from "../Elements/elementTypes"
import FormikCalendar from "../../../../../helpers/formikInputs/FormikCalendar"
import { DateTime } from "luxon"
import {
  getAssessmentDateOnlyFromIso,
  getAssessmentDateOnlyISO,
  getAssessmentTimeOnlyFromIso,
  getAssessmentTimeOnlyISO,
} from "../../helpers/assessmentDateHelper"
import { useEffect } from "react"

export default function QuestionMinMaxValue({
  formikQuestionName,
  questionType,
  disabled,
}) {
  const formikNameMin = `${formikQuestionName}.minValue`
  const formikNameMax = `${formikQuestionName}.maxValue`
  const formikNameMin_tmp = `${formikNameMin}_tmp`
  const formikNameMax_tmp = `${formikNameMax}_tmp`

  const [minField, , minHelpers] = useField(formikNameMin)
  const [maxField, , maxHelpers] = useField(formikNameMax)
  const [minTmpField, , minTmpHelpers] = useField(formikNameMin_tmp)
  const [maxTmpField, , maxTmpHelpers] = useField(formikNameMax_tmp)

  useEffect(() => {
    switch (questionType) {
      case elementTypes.dateElementId:
      case elementTypes.timeElementId:
        const curremtMinValue = DateTime.fromJSDate(minTmpField.value)
        const curremtMiaxValue = DateTime.fromJSDate(maxTmpField.value)

        if (!curremtMinValue.isValid && minField.value) {
          const minValue =
            questionType === elementTypes.dateElementId
              ? getAssessmentDateOnlyFromIso(minField.value).toJSDate()
              : getAssessmentTimeOnlyFromIso(minField.value)

          minTmpHelpers.setValue(minValue)
        }

        if (!curremtMiaxValue.isValid && maxField.value) {
          const maxValue =
            questionType === elementTypes.dateElementId
              ? getAssessmentDateOnlyFromIso(maxField.value).toJSDate()
              : getAssessmentTimeOnlyFromIso(maxField.value)

          maxTmpHelpers.setValue(maxValue)
        }
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let component = undefined

  switch (questionType) {
    case elementTypes.dateElementId:
      let maxDate = getAssessmentDateOnlyISO(maxField.value)
      let minDate = getAssessmentDateOnlyISO(minField.value)

      maxDate = maxDate?.isValid
        ? maxDate.plus({ days: -1 }).toJSDate()
        : undefined
      minDate = minDate?.isValid
        ? minDate.plus({ days: 1 }).toJSDate()
        : undefined

      component = (
        <>
          <FormikCalendar
            name={formikNameMin_tmp}
            label={"Minimum date"}
            maxDate={maxDate}
            onChangeCallBack={(value) => {
              if (value) {
                const minDate = getAssessmentDateOnlyISO(value)

                minHelpers.setValue(minDate)
              } else {
                minHelpers.setValue("")
              }
            }}
            showIcon
            disabled={disabled}
          />

          <FormikCalendar
            name={formikNameMax_tmp}
            label={"Maximim date"}
            minDate={minDate}
            onChangeCallBack={(value) => {
              if (value) {
                let maxDate = getAssessmentDateOnlyISO(value)

                maxHelpers.setValue(maxDate)
              } else {
                maxHelpers.setValue("")
              }
            }}
            showIcon
            disabled={disabled}
          />
        </>
      )

      break
    case elementTypes.timeElementId:
      let maxTime = getAssessmentTimeOnlyFromIso(maxField.value)
      let minTime = getAssessmentTimeOnlyFromIso(minField.value)

      maxTime = maxTime.isValid
        ? maxTime.plus({ minute: -1 }).toJSDate()
        : undefined
      minTime = minTime.isValid
        ? minTime.plus({ minute: 1 }).toJSDate()
        : undefined

      component = (
        <>
          <FormikCalendar
            name={formikNameMin_tmp}
            label={"Minimum time"}
            maxDate={maxTime}
            disableFormikSubmit={true}
            onChangeCallBack={(value) => {
              if (value) {
                const minTime = getAssessmentTimeOnlyISO(value)
                const minTempTime = getAssessmentTimeOnlyFromIso(minTime)

                minHelpers.setValue(minTime)
                minTmpHelpers.setValue(minTempTime)
              } else {
                minHelpers.setValue("")
              }
            }}
            showIcon
            iconPos="left"
            timeOnly={true}
            icon={<span class="material-icons">schedule</span>}
            disabled={disabled}
          />

          <FormikCalendar
            name={formikNameMax_tmp}
            label={"Maximim time"}
            minDate={minTime}
            disableFormikSubmit={true}
            onChangeCallBack={(value) => {
              if (value) {
                const maxTime = getAssessmentTimeOnlyISO(value)
                const maxTempTime = getAssessmentTimeOnlyFromIso(maxTime)

                maxHelpers.setValue(maxTime)
                maxTmpHelpers.setValue(maxTempTime)
              } else {
                maxHelpers.setValue("")
              }
            }}
            showIcon
            iconPos="left"
            timeOnly={true}
            icon={<span class="material-icons">schedule</span>}
            disabled={disabled}
          />
        </>
      )

      break
    default:
      component = (
        <div className={myStyles.numberContainer}>
          <FormikNumberInput
            name={formikNameMin}
            label={"Minimum value"}
            maxValue={maxField.value === "" ? undefined : maxField.value}
            minFractionDigits={0}
            showButtons
            disabled={disabled}
            onChangeCallBack={(newValue) => {
              minHelpers.setValue(`${newValue}`)
            }}
            disableFormikSubmit={true}
          />
          <FormikNumberInput
            name={formikNameMax}
            label={"Maximum value"}
            minValue={minField.value === "" ? undefined : minField.value}
            minFractionDigits={0}
            showButtons
            disabled={disabled}
            onChangeCallBack={(newValue) => {
              maxHelpers.setValue(`${newValue}`)
            }}
            disableFormikSubmit={true}
          />
        </div>
      )
      break
  }

  return component
}
